import { createSlice } from "@reduxjs/toolkit";

const firstPasswordChangeSlice = createSlice({
  name: "firstPasswordChange",
  initialState: {
    data: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    firstPasswordChangeStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    firstPasswordChangeSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    firstPasswordChangeFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    resetFirstPasswordChange(state) {
      state.data = null;
      state.error = null;
      state.isLoading = false;
    },
  },
});

export const {
  firstPasswordChangeStart,
  firstPasswordChangeSuccess,
  firstPasswordChangeFailure,
} = firstPasswordChangeSlice.actions;
export default firstPasswordChangeSlice.reducer;
